module.exports = __webpack_public_path__ + "static/cwr_group.188e6e34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cwr_group.jpg
// module id = 153
// module chunks = 35783957827783 80860605978170